import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IRevenueApiService } from './revenue-api.interface';
import { SuccessResponse } from '../../../shared/success-response';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';
import { FindRevenueResponseDto } from './dtos/find-revenue.response.dto';
import { FindRevenueQueryDto } from './dtos/find-revenue.query.dto';
import { SALES_ANALYTICS_API_URL } from '../sales-analytics-api.constants';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportRevenueQueryDto } from './dtos/export-revenue.query.dto';

@Injectable({
  providedIn: 'root',
})
export class RevenueApiService implements IRevenueApiService {
  private readonly ENDPOINT = 'revenue-transactions';

  // TODO: Align endpoint naming — GET and EXPORT should be the same for consistency.
  // Note: Other services already share identical names for get/export.
  private readonly EXPORT_ENDPOINT = 'revenue';

  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findRevenue(
    query: FindRevenueQueryDto
  ): Promise<FindRevenueResponseDto> {
    const params = new HttpParams({ fromObject: query as any });

    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindRevenueResponseDto>>(
        `${SALES_ANALYTICS_API_URL}/${this.ENDPOINT}`,
        { params }
      )
    );

    return response.data;
  }

  exportRevenue(
    query: ExportRevenueQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const { print = false } = options ?? {};
    const params = new HttpParams({ fromObject: query as any });

    this.exportService.export({
      endpoint: this.EXPORT_ENDPOINT,
      params,
      print,
    });
  }
}
